var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "px-3" },
    [
      _c(
        "router-link",
        {
          staticClass: "lecture-list--lecture py-2 w-100 d-flex",
          attrs: {
            "active-class": "active",
            tag: "div",
            to: {
              name: "lecture",
              params: {
                course: _vm.$route.params.course,
                lecture: _vm.lecture.id,
              },
            },
          },
        },
        [
          _vm.isAuthenticated
            ? _c(
                "div",
                {
                  staticClass: "small",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.toggleCompleted(_vm.lecture, $event)
                    },
                  },
                },
                [
                  _c("input", {
                    staticClass: "mx-2",
                    staticStyle: { "accent-color": "#212529" },
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isCompleted },
                  }),
                ]
              )
            : _c("div", {}, [
                _c("i", { staticClass: "far fa-square text-muted px-2" }),
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "pe-4 w-100" }, [
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c(
                "div",
                { staticClass: "small", class: { completed: _vm.isCompleted } },
                [
                  _vm.isStarred
                    ? _c("i", { staticClass: "fas fa-star text-warning" })
                    : _vm._e(),
                  _vm._v(
                    "\n          " + _vm._s(_vm.lecture.title) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.lecture.is_free
                ? _c(
                    "div",
                    {
                      staticClass: "small fw-bold text-uppercase text-success",
                    },
                    [_c("small", [_vm._v("Free")])]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.lecture.duration
              ? _c("div", { staticClass: "small" }, [
                  _c("small", [
                    _c("i", { staticClass: "far fa-clock" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.duration(_vm.lecture.duration)) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }